import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { IMAGE_MANAGEMENT_URL } from 'ZalamoLibrary/src/lib/zalamo/photo-manager/consts';
import { FullscreenService } from '@ui/fullscreen/fullscreen.service';
import { groupArrayByIndex } from '../../../../../../helpers/array';
import { localFontList } from '@ui/fonts-manager/localFontList';

const indexedLocalFonts = groupArrayByIndex(localFontList, 'fontId');

const cache = new Map();
declare let FontFace: any;

@Injectable({
  providedIn: 'root',
})
export class FontLoaderService {
  constructor(
    private httpClient: HttpClient,
    @Inject(IMAGE_MANAGEMENT_URL) private imageManagementUrl: string,
    private fullscreenService: FullscreenService,
  ) {}

  loadFont(
    fontId: string,
    fileName: string,
    organizationId: string,
  ): Observable<any> {
    if (!cache.has(fontId)) {
      cache.set(
        fontId,
        of(null).pipe(
          switchMap(() =>
            fontId.startsWith('local-')
              ? fetch(
                  `/assets/fonts/${fontId}.${indexedLocalFonts[fontId].type}`,
                ).then((r) => r.blob())
              : this.httpClient.get(`${this.imageManagementUrl}/font`, {
                  params: {
                    fileName,
                    organizationId,
                  },
                  responseType: 'blob',
                }),
          ),
          switchMap((fontFile) => {
            return new Observable((subscriber) => {
              const file = URL.createObjectURL(fontFile);

              const font = new FontFace(fontId, `url(${file})`);
              font.load().then(
                (loadedFont) => {
                  // @ts-ignore
                  document.fonts.add(loadedFont);
                  subscriber.next(undefined);
                },
                async (error) => {
                  // const allFonts = await firstValueFrom(
                  //   this.fontsManagerService.getFonts(),
                  // );
                  this.fullscreenService.open({
                    content: `Nie udało się załadować czcionki`,
                    data: {
                      mode: 'warn',
                    },
                  });
                },
              );
            });
          }),
          shareReplay(1),
        ),
      );
    }

    return cache.get(fontId);
  }
}
